// Message code define


// Endpoint
export const LocationActivityPoint = {
  CREATE: 'admin/location-activity-event/create',
  UPDATE: 'admin/location-activity-event/update',
  DELETE: 'admin/location-activity-event/delete',
}